import CarrierDetailResources from './CarrierDetailResources';
import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

const TITLE_CLASS =
  'm-0 shrink-0 text-left text-base font-medium tracking-wide text-black';

/**
 * Work Drive / carrier resources block: section title + embed.
 * @param {'full' | 'splitHalf'} layout — full column height, or lower half of a 50/50 split.
 * @param {boolean} withTopSeparator — when `splitHalf`, show border-top (off if parent already adds gap).
 */
export default function ResourcesFrame({ carrier, layout = 'full', withTopSeparator = true }) {
  if (!carrier?.workDriveFolderURL) return null;

  const isSplitHalf = layout === 'splitHalf';

  return (
    <div
      className={cn(
        'flex min-h-0 flex-col overflow-hidden',
        isSplitHalf
          ? cn(
              'w-full max-h-[50%] flex-[1_1_50%]',
              withTopSeparator && 'border-t border-grey-lightest pt-2'
            )
          : 'h-full'
      )}
    >
      <p className={cn(TITLE_CLASS, isSplitHalf ? 'mb-2 mt-3 ml-3 font-bold' : 'mb-3 mt-3 ml-4 font-bold text-lg') }>Carrier Resources</p>
      <div className='flex min-h-0 flex-1 flex-col overflow-hidden'>
        <CarrierDetailResources
          carrier={carrier}
          fillHeight
          showSubheading={false}
        />
      </div>
    </div>
  );
}

ResourcesFrame.propTypes = {
  carrier: propTypes.object.isRequired,
  layout: propTypes.oneOf(['full', 'splitHalf']),
  withTopSeparator: propTypes.bool
};
